import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { localeFromPath } from '../../i18n/path-locale';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  // Privacy + Terms are static HTML pages. About/Contact/FAQ are prerendered
  // React routes. All use regular <a> links so the browser does a full
  // navigation — Netlify serves the prerendered file directly and avoids
  // hydration issues from in-tree route transitions.
  const isFr = localeFromPath(location.pathname) === 'fr';
  const prefix = isFr ? '/fr' : '';
  // Legal slugs are language-specific (long-form canonical per CTO brief
  // for Google Play + Stripe + transactional email references).
  const privacyUrl = isFr ? '/fr/politique-de-confidentialite' : '/privacy-policy';
  const termsUrl = isFr ? '/conditions-utilisation' : '/terms-of-service';

  return (
    <footer className="bg-brand-text text-white/70 py-10 text-center">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6">
        <div className="mb-5 flex items-center justify-center gap-2.5">
          <img src="/images/landing/aidfone-favicon.png" alt="AidFone" width={24} height={24} className="w-6 h-6 object-contain" />
          <span className="text-white font-display text-xl font-bold">AidFone</span>
        </div>
        <p className="text-[0.9rem] mb-4">
          {t('landing.footer.tagline')}
        </p>
        <div className="flex flex-wrap justify-center gap-3 sm:gap-6 text-[0.85rem]">
          <a href="#features" className="text-white/70 no-underline hover:text-white">{t('landing.footer.linkFeatures')}</a>
          <a href="#pricing" className="text-white/70 no-underline hover:text-white">{t('landing.footer.linkPricing')}</a>
          <a href={`${prefix}/about`} className="text-white/70 no-underline hover:text-white">{t('landing.footer.linkAbout')}</a>
          <a href={`${prefix}/faq`} className="text-white/70 no-underline hover:text-white">FAQ</a>
          <a href={`${prefix}/contact`} className="text-white/70 no-underline hover:text-white">{t('landing.footer.linkContact')}</a>
          <a href={privacyUrl} className="text-white/70 no-underline hover:text-white">{t('landing.footer.linkPrivacy')}</a>
          <a href={termsUrl} className="text-white/70 no-underline hover:text-white">{t('landing.footer.linkTerms')}</a>
        </div>
        <p className="mt-6 text-[0.8rem] opacity-60">
          {t('landing.footer.copyright')}
        </p>
      </div>
    </footer>
  );
};
